module.exports = __webpack_public_path__ + "media/app_register_final.9c74d400.mp4";